import React, { useState } from "react";
import { useSelector } from "react-redux";
import ReactPagination from "../../../layout/ReactPagination";
import PaginationDropdown from "../../../layout/PaginationDropdown";
import { curSym, getOrderStatus } from "../../../utils/pip";
import NoRecord from "../../../components/other/NoRecord";

const OrderList = () => {
  const { orderList } = useSelector((state) => state.orderReducer);
  const [orders, setOrders] = useState(orderList);

  const [currentPage, setCurrentPage] = useState(0);
  const [listPerPages, setPerPageList] = useState(5);

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  // Get paginated data for the current page
  const paginateOrders = orders?.slice(
    currentPage * listPerPages,
    (currentPage + 1) * listPerPages
  );

  return (
    <div class="col-md-8 offset-md-1 mb-4">
      <div class="ct_my_account_right">
        <h4 class="mb-4 text-dark">My Order</h4>
        <div class="table-responsive">
          <div class="site-blocks-table">
            <table class="table">
              <thead>
                <tr>
                  <th class="product-serial-number">S.No.</th>
                  <th class="product-thumbnail">Image</th>
                  <th class="product-name">Product</th>
                  <th class="product-price">Price</th>
                  <th class="product-quantity">Quantity</th>
                  <th class="product-total">Total</th>
                  <th class="product-total">Status</th>
                </tr>
              </thead>

              <tbody>
                {paginateOrders &&
                  paginateOrders?.length > 0 &&
                  paginateOrders?.map((order,index) => (
                    <tr key={order.id}>
                      <td className="product-serial-number">{index+1}</td>
                      <td className="product-thumbnail">
                        <img
                          src={order?.product_images.thumbnail}
                          alt={order?.product_details.product_name}
                          className="img-fluid ct_img_50"
                        />
                      </td>
                      <td className="product-name">
                        <h2 className="h5 text-black">
                          {order?.product_details.product_name}
                        </h2>
                      </td>
                      <td>
                        {" "}
                        {curSym}
                        {parseFloat(order?.product_details.price) -
                          parseFloat(order?.product_details.discount)}
                      </td>
                      <td>{order?.quantity}</td>
                      <td>
                        {curSym}
                        {order?.total_price}
                      </td>
                      <td>{getOrderStatus(order?.status)}</td>
                    </tr>
                  ))}
                <tr>
                  <td colSpan={5} className="border-0">
                    {paginateOrders && paginateOrders?.length <= 0 && (
                      <NoRecord className="text-center" />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {orders && orders?.length > 5 && (
            <>
              <div className="d-flex justify-content-between align-items-center mt-4 mx-3 mb-3">
                <div>
                  <PaginationDropdown
                    onChange={(val) => {
                      setPerPageList(val);
                      setCurrentPage(0);
                    }}
                  />
                </div>
                <div>
                  <ReactPagination
                    pageCount={Math.ceil(orders?.length / listPerPages)}
                    onPageChange={handlePageClick}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderList;
